export enum DIALOG_TYPES {
  SCHEDULE = 'SCHEDULE',
  DELETE = 'DELETE',
  RESET = 'RESET',
  MANUAL = 'MANUAL',
  GROUP = 'GROUP',
  MODIFY = 'MODIFY',
  UPDATE_ROWS = 'UPDATE_ROWS'
}
